/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhoneGps
 */
export interface PhoneGps {
    /**
     * 
     */
    latitude: number;
    /**
     * 
     */
    longitude: number;
    /**
     * 
     */
    accuracyM?: number | null;
}

/**
 * Check if a given object implements the PhoneGps interface.
 */
export function instanceOfPhoneGps(value: object): value is PhoneGps {
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    return true;
}

export function PhoneGpsFromJSON(json: any): PhoneGps {
    return PhoneGpsFromJSONTyped(json, false);
}

export function PhoneGpsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneGps {
    if (json == null) {
        return json;
    }
    return {
        
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'accuracyM': json['accuracy_m'] === undefined ? undefined : json['accuracy_m'] === null ? null : json['accuracy_m'],
    };
}

export function PhoneGpsToJSON(json: any): PhoneGps {
    return PhoneGpsToJSONTyped(json, false);
}

export function PhoneGpsToJSONTyped(value?: PhoneGps | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'accuracy_m': value['accuracyM'],
    };
}

